<template>
  <div
    v-bind="$attrs"
    class="page justopp plain-layout default-layout--plain">
    <justopp-header></justopp-header>
    <main class="min-height-page relative">
      <slot></slot>
    </main>
    <register-cta-section></register-cta-section>
    <justopp-footer></justopp-footer>
    <site-credits></site-credits>
    <justopp-mobile-footer />
  </div>
</template>

<script>
import JustoppHeader from "@/client/applications/justopp/components/JustoppHeader";
import JustoppFooter from "@/client/applications/justopp/components/JustoppFooter";
import JustoppMobileFooter from "@/client/applications/justopp/components/JustoppMobileFooter";
import RegisterCtaSection from "@/client/applications/justopp/components/RegisterCtaSection";
export default {
  components: { JustoppHeader, JustoppFooter, RegisterCtaSection, JustoppMobileFooter },
  props: {
    /*
     backgroundImage: {
     type: String,
     default: 'page-bg-texture.png',
     }
     */
  },
  data() {
    return {
      // showHeader: this.$store.getters['talron/showHeader'],
    };
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
